import service from '@/service'

// 补货单列表
export function getList(data) {
  return service['api-scm']({
    url: '/replenishOrderController/findReplenishOrder',
    method: 'post',
    data
  })
}

// 查询供货授权
export function findListByProductList(data) {
  return service['api-scm']({
    url: '/replenishOrderController/findListByProductList',
    method: 'post',
    data
  })
}

// 查询库存
export function inventoryDetailList(data) {
  return service['api-scm']({
    url: '/replenishOrderController/findInventory',
    method: 'post',
    data
  })
}

// 导出补货单列表
export function exportList(data) {
  return service['api-scm']({
    url: '/replenishOrderController/exportList',
    method: 'post',
    data
  })
}

// 重新匹配供应商
export function rematchSupplier(data) {
  return service['api-scm']({
    url: '/replenishOrderController/rematchSupplier',
    method: 'post',
    data
  })
}

// 转采购
export function generatePurchaseOrder(data) {
  return service['api-scm']({
    url: '/replenishOrderController/generatePurchaseOrder',
    method: 'post',
    data
  })
}

// 日志
export function findOrderLog(data) {
  return service['api-scm']({
    url: '/replenishOrderController/findOrderLog',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
